import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FiltriRichieste {
  anno: number;
  stato: string | null;
  ente: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class FiltriStatoService {
  private filtriRichiesteSubject = new BehaviorSubject<FiltriRichieste | null>(null);
  public filtriRichieste$ = this.filtriRichiesteSubject.asObservable();

  constructor() {}

  // Salva i filtri correnti delle richieste
  salvaFiltriRichieste(filtri: FiltriRichieste): void {
    console.log('[FILTRI-STATO] Salvando filtri:', filtri);
    this.filtriRichiesteSubject.next(filtri);
  }

  // Ottiene i filtri salvati delle richieste
  getFiltriRichieste(): FiltriRichieste | null {
    const filtri = this.filtriRichiesteSubject.value;
    console.log('[FILTRI-STATO] Recuperando filtri:', filtri);
    return filtri;
  }

  // Pulisce i filtri salvati
  pulisciFiltriRichieste(): void {
    this.filtriRichiesteSubject.next(null);
  }
}
